import React from "react";
import SkDatePicker from "./SkDatePicker";
import "../assets/css/formFields.css";

/**
 * A labelled date field.
 *
 * SkDatePicker is the calendar itself and knows nothing about labels or
 * errors; TextInput and SelectInput both wear .sk-field chrome. This puts the
 * one inside the other, so a date sitting in a form row lines up with the text
 * boxes and selects beside it and reports a validation error the same way.
 *
 * Speaks plain "YYYY-MM-DD" in and out, like SkDatePicker — but through
 * onChange(event)-shaped calls when `name` is given, so it drops into a form
 * whose fields are all driven by one handleChange.
 */
const DateInput = ({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  hint,
  disabled = false,
  minDate,
  maxDate,
  placeholder = "dd-mm-yyyy",
  width = "100%",
}) => (
  <div className="sk-field" style={{ width }}>
    {label && (
      <label className="sk-field__label" htmlFor={name}>
        {label}
        {required && <span className="sk-field__required">*</span>}
      </label>
    )}

    <SkDatePicker
      size="md"
      block
      value={value}
      /* Handed back as a synthetic { target: { name, value } } so a form can
         keep one handleChange for every field rather than a special case for
         this one. */
      onChange={(iso) => onChange?.({ target: { name, value: iso } })}
      placeholder={placeholder}
      invalid={!!error}
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      ariaLabel={name}
    />

    {hint && !error && <div className="sk-field__hint">{hint}</div>}

    {error && (
      <div className="sk-field__error">
        <i className="bi bi-exclamation-circle-fill" aria-hidden="true" />
        <span>{error}</span>
      </div>
    )}
  </div>
);

export default DateInput;
